/** The console's member counts in words (#2833). */
import { peopleWords } from "./adminWords";

export interface MemberCounts {
  has_account: number;
  can_sign_in: number;
  placeholder: number;
  invited: number;
}

/** People on the roster in words: "Three people". Invited people are not on it yet. */
export function memberWords(counts: MemberCounts): string {
  return peopleWords(counts.has_account + counts.placeholder);
}

/** The split behind the words, for a tooltip or a quiet second line. Zeros are left out. */
export function memberSplit(counts: MemberCounts): string {
  const parts: string[] = [];
  if (counts.has_account > 0) parts.push(`${counts.has_account} have an account`);
  if (counts.can_sign_in > 0) parts.push(`${counts.can_sign_in} can sign in on the web`);
  if (counts.placeholder > 0) {
    parts.push(
      `${counts.placeholder} ${counts.placeholder === 1 ? "placeholder" : "placeholders"}`,
    );
  }
  if (counts.invited > 0) parts.push(`${counts.invited} invited`);
  return parts.join(" \u00b7 ");
}
